export enum PlayingTypes {
  Slow = 'slow',
  Default = 'default',
}
